import PropTypes from 'prop-types'
import React from 'react'

// Components
import { Note } from '../Note/Note'
import { BusinessNote } from '../BusinessNote'
import { S_EmptyMessage } from '../../EmptyMessage'
import { S_NoteList } from './NoteList.styles'
import { H4 } from '../../Typography/Components/Headings/H4'
import { TimeLineNote } from '../TimeLineNote/TimeLineNote'

export const NoteList = ({
  label,
  notes = [],
  noteStyle = '',
  allowEdit = false,
  allowRemove = false,
  allowPin = false,
  onRemoveNote = () => {},
  onUpdateNote = () => {},
  onPinNote = () => {},
}) => {
  const isBusinessNote = noteStyle === 'businessNotes'
  const isTimeLine = noteStyle === 'timeline'

  const renderNote = (note, noteIndex) => {
    if (isBusinessNote) {
      return (
        <BusinessNote
          allowEdit={allowEdit}
          allowPin={allowPin}
          allowRemove={allowRemove}
          note={note}
          onPin={(pinVal) => onPinNote(noteIndex, pinVal)}
          onRemove={() => onRemoveNote(noteIndex)}
          onUpdate={(newNote) => onUpdateNote(noteIndex, newNote)}
        />
      )
    } else if (isTimeLine) {
      return (
        <TimeLineNote
          note={note}
          onRemove={() => onRemoveNote(noteIndex)}
          onUpdate={(newNote) => onUpdateNote(noteIndex, newNote)}
        />
      )
    } else {
      return <Note icon={note.icon} message={note.message} tenant={note.tenant} />
    }
  }

  return (
    <S_NoteList>
      <H4 mb={'15px'}>{label}</H4>
      <div className={'note-list'}>
        {notes.map((note, noteIndex) => (
          <div className={'note'} key={note.id}>
            {renderNote(note, noteIndex)}
          </div>
        ))}
        {isBusinessNote && !notes.length && <S_EmptyMessage>No notes found </S_EmptyMessage>}
      </div>
    </S_NoteList>
  )
}

NoteList.propTypes = {
  allowEdit: PropTypes.bool,
  allowRemove: PropTypes.bool,
  allowPin: PropTypes.bool,
  label: PropTypes.any,
  noteStyle: PropTypes.string,
  notes: PropTypes.array,
  onRemoveNote: PropTypes.func,
  onUpdateNote: PropTypes.func,
  onPinNote: PropTypes.func,
}
